import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["description"]
  static values = {
    descriptions: Object
  }

  update(event) {
    const selectedType = event.target.value
    
    if (selectedType && this.descriptionsValue[selectedType]) {
      this.descriptionTarget.textContent = this.descriptionsValue[selectedType]
      this.descriptionTarget.classList.remove("hidden")
    } else {
      this.descriptionTarget.textContent = ""
      this.descriptionTarget.classList.add("hidden")
    }
  }
}
